export const SLIDER_SIZE_SETTINGS = {
  desktop: {
    width: '1466',
    height: '900'
  },
  tablet: {
    width: '100',
    height: '563'
  },
  mobile: {
    width: '100',
    height: '520'
  }
};
export const SINGLE_IMAGE_SIZE_SETTINGS = {
  desktop: {
    width: '600',
    height: '900'
  },
  tablet: {
    width: '600',
    height: '563'
  },
  mobile: {
    width: '375',
    height: '520'
  }
};
export const SQUARE_IMAGE_SIZE_SETTINGS = {
  desktop: {
    width: '900',
    height: '900'
  },
  tablet: {
    width: '754',
    height: '563'
  },
  mobile: {
    width: '754',
    height: '520'
  }
};

// ----------Full mode gallery------------
export const FULL_MODE_IMAGE_HEIGHT = 60;
export const FULL_MODE_IMAGE_ACTIVE_HEIGHT = 80;

// ----------Mobile gallery------------
export const THUMB_IMG_HEIGHT = 60;
export const SLIDER_CONTAINER_HEIGHT = 250;
export enum VisibleSectionType {
  PRODUCT_SLIDES = 'PRODUCT_SLIDES',
  PRODUCT_DESCRIPTIONS = 'PRODUCT_DESCRIPTIONS',
  PRODUCT_DELIVERY_ASSEMBLY = 'PRODUCT_DELIVERY_ASSEMBLY',
  ABOUT_COLLECTION = 'ABOUT_COLLECTION',
  YOUR_PHOTOS = 'YOUR_PHOTOS',
}
export type StickyBarLinkType = {
  href: string;
  text: string;
  offsetY: number;
};
export const STICKYBAR_MAP: Map<VisibleSectionType, StickyBarLinkType> = new Map([[VisibleSectionType.PRODUCT_SLIDES, {
  href: `#${VisibleSectionType.PRODUCT_SLIDES}`,
  text: 'photos',
  offsetY: 100
}], [VisibleSectionType.PRODUCT_DESCRIPTIONS, {
  href: `#${VisibleSectionType.PRODUCT_DESCRIPTIONS}`,
  text: 'description',
  offsetY: 150
}], [VisibleSectionType.PRODUCT_DELIVERY_ASSEMBLY, {
  href: `#${VisibleSectionType.PRODUCT_DELIVERY_ASSEMBLY}`,
  text: 'deliveryAssembly',
  offsetY: 150
}], [VisibleSectionType.YOUR_PHOTOS, {
  href: `#${VisibleSectionType.YOUR_PHOTOS}`,
  text: 'yourPhotos',
  offsetY: 100
}], [VisibleSectionType.ABOUT_COLLECTION, {
  href: `#${VisibleSectionType.ABOUT_COLLECTION}`,
  text: 'aboutCollection',
  offsetY: 100
}]]);
export const PRODUCT_LISTING_SCOPE = ['id', 'name', 'files', 'rap', 'features', 'flags'];
export const RELATED_PRODUCT_LISTING_SCOPE = ['id', 'name', 'files', 'flags', 'colorSwatch', 'basePrice', 'currentPrice', 'omnibusPrice', 'price'];
export const CONFIGURATOR_LOADING_TIMEOUT = 30000;
export const PHOTOSLURP_PHOTOS_IMG = 'https://static10.vox.pl/files/assets/img/lp/baner/baner_instagram_mobile.jpg';